import { __decorate } from 'tslib';
import { Pipe, NgModule } from '@angular/core';
import { orderBy } from 'lodash';

import * as ɵngcc0 from '@angular/core';
let SortByPipe = class SortByPipe {
    transform(value, order = '', column = '') {
        if (!value || order === '' || !order) {
            return value;
        } // no array
        if (!column || column === '') {
            if (order === 'asc') {
                return value.sort();
            }
            else {
                return value.sort().reverse();
            }
        } // sort 1d array
        if (value.length <= 1) {
            return value;
        } // array with only one item
        return orderBy(value, [column], [order]);
    }
};
SortByPipe.ɵfac = function SortByPipe_Factory(t) { return new (t || SortByPipe)(); };
SortByPipe.ɵpipe = /*@__PURE__*/ ɵngcc0.ɵɵdefinePipe({ name: "sortBy", type: SortByPipe, pure: true });

let NgpSortModule = class NgpSortModule {
};
NgpSortModule.ɵfac = function NgpSortModule_Factory(t) { return new (t || NgpSortModule)(); };
NgpSortModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: NgpSortModule });
NgpSortModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({});
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(SortByPipe, [{
        type: Pipe,
        args: [{ name: 'sortBy' }]
    }], null, null); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(NgpSortModule, [{
        type: NgModule,
        args: [{
                declarations: [SortByPipe],
                exports: [SortByPipe]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(NgpSortModule, { declarations: [SortByPipe], exports: [SortByPipe] }); })();

/*
 * Public API Surface of ngp-sort
 */

/**
 * Generated bundle index. Do not edit.
 */

export { NgpSortModule, SortByPipe };

//# sourceMappingURL=ngp-sort-pipe.js.map